export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
